import React from 'react';
import './list.scss';
import MainSidebar from "../../components/sidebar/mainSidebar";
import NavBar from "../../components/navbar/navbar";
import ResultsDatatable from "../../components/datatable/resultDatatableAdmin";

const ListResults = () => {
    return (
        <div className="list">
            <MainSidebar/>
            <div className="listContainer">
                <NavBar/>
                <ResultsDatatable/>
            </div>
        </div>
    );
}
export default ListResults